import { render, staticRenderFns } from "./LayoutSelection.vue?vue&type=template&id=529c9de9&scoped=true&"
import script from "./LayoutSelection.vue?vue&type=script&lang=js&"
export * from "./LayoutSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529c9de9",
  null
  
)

export default component.exports